import { useCallback, useMemo, useState } from 'react'
import { useIntl } from 'react-intl'
import { dealerConfigureHostRestart } from '@racepointenergy/swc/scs/dealer-configure-host-restart'

import { KebabMenu } from 'components/KebabMenu'
import HomeKebabModal from './HomeKebabModal'
import { HomeStatusKebabContainer, HomeStatusKebabItem } from '../styles'
import { processMessages } from 'features/home/components/HomeProcesses/messages'

const kebabArray = [
  {
    title: processMessages.hardwareRebootButton,
    isRenderModal: true,
    modalTitle: processMessages.rebootHardwareTitle,
    modalLabel: processMessages.rebootHardwareBody,
  },
  {
    title: processMessages.softwareRebootButton,
    isRenderModal: true,
    modalTitle: processMessages.rebootSoftwareTitle,
    modalLabel: processMessages.rebootSoftwareBody,
  },
]

type ArrayElement<ArrayType extends readonly unknown[]> =
  ArrayType extends readonly (infer ElementType)[] ? ElementType : never

interface HomeKebabMenuProps {
  homeId: string
  updateConfigureHostRestart: ReturnType<
    typeof dealerConfigureHostRestart.useMutation
  >[0]
  isLoading?: boolean
}

function HomeKebabMenu({
  homeId,
  updateConfigureHostRestart,
  isLoading,
}: HomeKebabMenuProps) {
  const { formatMessage } = useIntl()
  const [isOpen, setIsOpen] = useState(false)
  const [selectedItem, setSelectedItem] = useState<any>({})
  const onClose = useCallback(() => setIsOpen(false), [setIsOpen])

  const restartHost = useCallback(
    (hard: boolean) => () => {
      updateConfigureHostRestart({ id: homeId, hard })
      onClose()
    },
    [updateConfigureHostRestart, onClose, homeId]
  )

  const kebabArrayWithFunctions = useMemo(
    () =>
      kebabArray.map((i) => {
        switch (i.title) {
          case processMessages.hardwareRebootButton:
            return {
              ...i,
              onSuccess: restartHost(true),
            }
          case processMessages.softwareRebootButton:
            return {
              ...i,
              onSuccess: restartHost(false),
            }
          default:
            return i
        }
      }),
    [restartHost]
  )

  const handleClick =
    (item: ArrayElement<typeof kebabArrayWithFunctions>) => () => {
      setSelectedItem(item)
      setIsOpen(true)
    }

  return (
    <>
      <KebabMenu>
        <HomeStatusKebabContainer>
          {kebabArrayWithFunctions.map((item) => (
            <HomeStatusKebabItem
              key={item.title.id}
              onClick={handleClick(item)}
              disabled={isLoading}
            >
              {formatMessage(item.title)}
            </HomeStatusKebabItem>
          ))}
        </HomeStatusKebabContainer>
      </KebabMenu>
      <HomeKebabModal
        isOpen={isOpen && selectedItem.isRenderModal}
        onClose={onClose}
        onSuccess={selectedItem.onSuccess}
        modalTitle={
          selectedItem.modalTitle ? formatMessage(selectedItem.modalTitle) : ''
        }
        modalLabel={
          selectedItem.modalLabel
            ? formatMessage(selectedItem.modalLabel, { br: <br /> })
            : ''
        }
      />
    </>
  )
}

export default HomeKebabMenu
